module.exports = __webpack_public_path__ + "img/cxm.bee2d524.jpg";